// src/components/Dashboard/AnalyticsSummary.jsx

import React, { useState, useEffect } from "react";
import { Users, Star, TrendingUp } from "lucide-react";
import api from "../../api/axios";
import { useLanguage } from "../../context/LanguageContext";

export default function AnalyticsSummary() {
  const { t } = useLanguage();
  const [summary, setSummary] = useState({ totalSessions: "...", averageRating: "..." });

  useEffect(() => {
    api.get("/analytics/dashboard?range=7").then(res => {
      setSummary({
        totalSessions: res.data.totalSessions?.toString() || "0",
        averageRating: res.data.averageRating || t('dash_new')
      });
    }).catch(err => console.error("Could not fetch analytics summary", err));
  }, [t]);

  const stats = [
    { label: t('dash_sessions_label'), value: summary.totalSessions, icon: Users, color: "text-blue-500", bg: "bg-blue-50 dark:bg-blue-900/20" },
    { label: t('dash_rating_label'), value: summary.averageRating, icon: Star, color: "text-yellow-500", bg: "bg-yellow-50 dark:bg-yellow-900/20" },
  ];

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow h-full flex flex-col justify-center">
      <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-gray-100 flex items-center gap-2">
        <TrendingUp className="w-5 h-5 text-indigo-500" /> {t('dash_weekly_impact')}
      </h2>
      <div className="grid grid-cols-2 gap-3">
        {stats.map((stat, i) => (
          <div key={i} className={`p-3 rounded-lg ${stat.bg} flex flex-col items-center justify-center text-center`}>
            <stat.icon className={`w-5 h-5 ${stat.color} mb-1`} />
            <span className="text-2xl font-bold text-gray-800 dark:text-gray-100">{stat.value}</span>
            <span className="text-xs text-gray-500 dark:text-gray-400 font-medium">{stat.label}</span>
          </div>
        ))}
      </div>
      <p className="mt-4 text-[10px] text-center text-gray-400">
        {t('dash_updated_just_now')}
      </p>
    </div>
  );
}